import React from 'react';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import baseStyles from './partitioned_page.module.css';


type PartitionedPageStyles = {
  background: string;
  container: string;
  topSection: string;
  middleSection: string;
  bottomSection: string;
};

const themedStyles: ThemedStyles<PartitionedPageStyles> = {
  [Theme.DAYLIGHT]: {
    background: baseStyles.daylightBackground,
    container: baseStyles.container,
    topSection: baseStyles.topSection,
    middleSection: baseStyles.middleSection,
    bottomSection: baseStyles.bottomSection,
  },
  [Theme.MIDNIGHT]: {
    background: baseStyles.midnightBackground,
    container: baseStyles.container,
    topSection: baseStyles.topSection,
    middleSection: baseStyles.middleSection,
    bottomSection: baseStyles.bottomSection,
  },
};

export type PartitionedPageProps = {
  top: React.ReactNode;
  middle: React.ReactNode;
  bottom: React.ReactNode;
};

export const PartitionedPage = React.memo(({ top, middle, bottom }: PartitionedPageProps) => {
  const styles = useStyles(themedStyles);
  return (
    <div className={styles.background}>
      <div className={styles.container}>
        <div className={styles.topSection}>
          {top}
        </div>
        <div className={styles.middleSection}>
          {middle}
        </div>
        <div className={styles.bottomSection}>
          {bottom}
        </div>
      </div>
    </div>
  );
});

PartitionedPage.displayName = 'PartitionedPage';
